// extracted by mini-css-extract-plugin
export default {"root":"CorporateAccountImportUsersWizard_root__nJ5NJ"};